import { apiClient } from './client';
import type { OscarConfig, HealthResponse } from '@/types/oscar';

/** GET /api/config — Settings page env-var reflector. */
export function getConfig(signal?: AbortSignal): Promise<OscarConfig> {
  return apiClient.get<OscarConfig>('/api/config', signal);
}

/** GET /api/healthz — liveness probe (anonymous). */
export function getHealth(signal?: AbortSignal): Promise<HealthResponse> {
  return apiClient.get<HealthResponse>('/api/healthz', signal);
}
